import React from 'react';
import PropTypes from 'prop-types';
import { DOMAIN_ACTION_LOADING_MESSAGES } from './constants';

import { withStyles } from '@material-ui/core/styles';

import LoadingSpinner from '../../../common/components/loading-spinner';
import Typography from 'fuse-ui/components/Typography';

const styles = ( theme ) => ( {
    container: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        width: '100%',
    },
    loadingSpinner: {
        height: 'auto',
        width: 'auto'
    },
    typographyRoot: {
        marginTop: theme.spacing.unit,
    }
} );

const DomainManagementBulkLoading = ( { classes, domainActionType } ) => {
    return (
        <div className={classes.container}>
            <LoadingSpinner className={classes.loadingSpinner} />
            <Typography
                classes={{ root: classes.typographyRoot }} >
                {DOMAIN_ACTION_LOADING_MESSAGES[domainActionType]}
            </Typography>
        </div>
    );
};

DomainManagementBulkLoading.propTypes = {
    classes: PropTypes.object,
    domainActionType: PropTypes.string,
};

export default withStyles( styles )( DomainManagementBulkLoading );
